export default __webpack_public_path__ + "static/media/vlaanderen_omgeving@2x.5aedb83f.png";